import { HttpErrorResponse } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { Action } from "@ngrx/store";
import { Observable, of } from "rxjs";
import { catchError, exhaustMap, map } from "rxjs/operators";
import { AuthenticationService, DocumentGroup, DocumentsService, NewsItem, NewsService, PermissionsApi, PriceList, PricelistsService } from "src/app/generated/CrossPoint.Sales.Server";
import { IDataAction } from "src/app/utils/interfaces/common.interfaces";
import { IGetNewsItems, IGetPriceLists } from "src/app/utils/interfaces/remote-maintenance.interfaces";
import { errorEventAction } from "../actions/app.actions";
import { getAuthInfoSalesFailedAction, getAuthInfoSalesSuccessAction, getDocumentsFailedAction, getDocumentsSuccessAction, getNewsFailedAction, getNewsSuccessAction, getPriceListsFailedAction, getPriceListsSuccessAction, SalesActionsTypes } from "../actions/sales.actions";


@Injectable()
export class SalesEffects {

  public getAuthInfoDevicesEffect$: Observable<Action> = createEffect(() =>
    this.actions$
      .pipe(
        ofType(SalesActionsTypes.GET_AUTH_INFO_SALES),
        exhaustMap(() => this.authenticationService.getPermissions()
          .pipe(
            map((permissions: PermissionsApi) => getAuthInfoSalesSuccessAction({ data: permissions.permissions })),
            catchError((error: HttpErrorResponse) => {
              return of(errorEventAction({ data: { error: error, translationkey: "StoreActionFailed.GetAuthInfoSalesErrorHasOccurred" } }), getAuthInfoSalesFailedAction())
            })
          )
        )
      )
  );

  public getNewsEffect$: Observable<Action> = createEffect(() =>
    this.actions$
      .pipe(
        ofType(SalesActionsTypes.GET_NEWS),
        exhaustMap(({ data: { lastId, includeUnpublished } }: IDataAction<IGetNewsItems>) =>
          this.newsService.getNews(lastId, includeUnpublished)
            .pipe(
              map((news: NewsItem[]) => getNewsSuccessAction({ data: news })),
              catchError((error: HttpErrorResponse) => {
                return of(errorEventAction({ data: { error: error, translationkey: "StoreActionFailed.GetNewsErrorHasOccurred" } }), getNewsFailedAction())
              })
            )
        )
      )
  );

  public getPriceListsEffect$: Observable<Action> = createEffect(() =>
    this.actions$
      .pipe(
        ofType(SalesActionsTypes.GET_PRICELISTS),
        exhaustMap(({ data: { dealerId, language } }: IDataAction<IGetPriceLists>) =>
          this.priceListsService.getPricelist(dealerId, language)
            .pipe(
              map((priceLists: PriceList) => getPriceListsSuccessAction({ data: priceLists })),
              catchError((error: HttpErrorResponse) => {
                return of(errorEventAction({ data: { error: error, translationkey: "StoreActionFailed.GetPriceListErrorHasOccurred" } }), getPriceListsFailedAction())
              })
            )
        )
      )
  );

  public getDocumentsEffect$: Observable<Action> = createEffect(() =>
    this.actions$
      .pipe(
        ofType(SalesActionsTypes.GET_DOCUMENTS),
        exhaustMap(() =>
          this.documentsService.getDocuments()
            .pipe(
              map((documents: DocumentGroup[]) => getDocumentsSuccessAction({ data: documents })),
              catchError((error: HttpErrorResponse) => {
                return of(errorEventAction({ data: { error: error, translationkey: "StoreActionFailed.GetDocumentsErrorHasOccurred" } }), getDocumentsFailedAction())
              })
            )
        )
      )
  );

  constructor(
    private actions$: Actions,
    private authenticationService: AuthenticationService,
    private newsService: NewsService,
    private priceListsService: PricelistsService,
    private documentsService: DocumentsService,
  ) { }
}
